import { toast } from "react-toastify";
import {EXPORT_MEMBER_REBATES, EXPORT_MEMBER_REBATE_ERROR, DOWNLOAD_DOCUMENT_ERROR} from "../../../constants";

export const exportMemberProductList = async ({
    exportQuarter,
    exportYear,
    exportStatus
}) => {
    try {
        const user = JSON.parse(localStorage.getItem("user"));
        const response = await fetch(`${EXPORT_MEMBER_REBATES}?quarter=${exportQuarter}&year=${exportYear}&status=${exportStatus}`, {
            headers: new Headers({
                "x-access-token": user.accessToken,
                "Content-Type": "application/json"
            }),
        });
        const responseJson = await response.json();
        
        if (responseJson.error) {
            toast.error(responseJson.error);
        }
        // if (!response.ok) throw DOWNLOAD_DOCUMENT_ERROR;
        return responseJson;
    } catch (error) {
        throw EXPORT_MEMBER_REBATE_ERROR;
    }
}

